const doc = [({"ko":({"adminConstantRoomPlanDisplayType":({"default":"기본", "noImage":"계획 이미지 없음", "onlyOne":"오직 하나", "onlyPlan":"계획만"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;